module.exports = __webpack_public_path__ + "static/img/3.7ae5672.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/my/0/3.png
// module id = RzZs
// module chunks = 1